<template>
  <div class="recos-view">
    <recommendations
      :results="results"
      @select="onPerfumeClick"
    ></recommendations>
  </div>
</template>

<script>
import Recommendations from "@/components/wikiparfum/Recommendations";
import { getPerfumes, track } from "@/services/api";

export default {
  components: { Recommendations },
  mounted() {
    track({
      name: "pageView",
      data: this.recosIds,
    });
  },
  asyncComputed: {
    results() {
      return getPerfumes(this.recosIds);
    },
  },
  computed: {
    recosIds() {
      return this.$route.query.recos.split(",");
    },
  },
  methods: {
    onPerfumeClick(perfume) {
      this.$router.push(`/perfume/${perfume.id}`);
    },
  },
};
</script>

<style scoped lang='stylus'>
.recos-view
  flex: 1 1 0%
  overflow-y: auto
</style>